import { ListMinus } from 'lucide-react';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Description, SubsectionTitle } from '@/components/ui/Title.tsx';

const NoItems = ({
  title,
  description,
  icon,
  compact,
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  title?: string;
  description?: string;
  icon?: ReactNode;
  /**
   * Pustka w dymku albo w wierszu listy, gdzie kafel ikony i nagłówek zjadłyby
   * więcej miejsca niż sama treść: ikona wraca do linii tekstu.
   */
  compact?: boolean;
}) => {
  if (compact) {
    return (
      <div
        className={cn(
          'flex items-center gap-2 text-neutral-500 [&>svg]:size-3.5 [&>svg]:shrink-0 [&>svg]:text-neutral-400',
          className,
        )}
        {...props}
      >
        {icon ?? <ListMinus />}
        <span className="text-xs">{title ?? 'No items to display'}</span>
        {description && (
          <span className="text-xs text-neutral-400">{description}</span>
        )}
        {children}
      </div>
    );
  }

  return (
    <div
      className={cn('flex max-w-[400px] flex-col items-start gap-3', className)}
      {...props}
    >
      <div className="rounded-md bg-neutral-50 p-2.5 [&>svg]:size-[18px] [&>svg]:text-neutral-400">
        {icon ?? <ListMinus />}
      </div>
      <div>
        {/*
         * Pustka mieszka wewnątrz sekcji albo karty, więc jej nagłówek musi
         * być cichszy od nagłówka gospodarza — wcześniejsze 18 px przebijało
         * nazwę ustawienia, którego pustka dotyczy.
         */}
        <SubsectionTitle className="text-sm">
          {title ?? 'No items to display'}
        </SubsectionTitle>
        {description && (
          <Description className="text-[13px] leading-[1.5] text-neutral-600">
            {description}
          </Description>
        )}
      </div>
      {children}
    </div>
  );
};

export default NoItems;
